import apiClient from './apiClient';

const userApi = {

  login: (email, password) => {
    return apiClient.post('/api/login', { login: email, password, expiration_minutes: 600 });
  },


  getUsersList: () => {
    return apiClient.get(`/api/users`);
  },


  getCurrentUser: (userId) => {
    return apiClient.get(`/api/users/${userId}`);
  },


  createNewUser: (keyspace_name, login, name, password, roles) => {
    return apiClient.post(`/api/users`, { keyspace_name, login, name, password, no_expiration: false, roles });
  },


  updateProfile: (userId, data) => {
    return apiClient.patch(`/api/users/${userId}`, data);
  },


  deleteUser: (userId) => {
    return apiClient.delete(`/api/users/${userId}`);
  },


  workspace: () => {
    return apiClient.get(`/api/workspace`);
  },
  workspaceUpdate: (data) => {
    return apiClient.put(`/api/workspace`, data);
  },

  getTemplateContext: (userId) => {
    return apiClient.get(`/api/template_context/${userId}`);
  },



  updateTemplateContext: ({ userid, template_saudacao, template_internet, template_contexto }) => {
    return apiClient.patch(`/api/template_context/${userid}`, {
      userid,
      template_saudacao,
      template_internet,
      template_contexto,
    });
  },
  createAccess: ({ keyspace_name,
    user_id,
    environment_id,
    isadmin, }) => {
    return apiClient.post(`/api/admin/create_access`, {
      keyspace_name,
      user_id,
      environment_id,
      isadmin,
    });
  },


  getEnvironments: () => {
    return apiClient.get(`/api/environment`);
  },
};

export default userApi;
